import { Box, MenuItem } from "@mui/material";
import { ChevronDown } from "lucide-react";

import { lucideSelectIcon } from "@/shared/ui/LucideSelectIcon";

import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

import useStyles from "./CustomDropDown.styles";
import clsx from "clsx";

interface CustomDropDownProps {
  readonly sx?: React.CSSProperties;
  readonly items?: number[] | string[];
  readonly value?: string | number;
  readonly disabled?: boolean;
  readonly handleChange?: (event: SelectChangeEvent) => void;
  readonly placeholder?: string;
  readonly className?: string;
  readonly values?: number[] | string[];
  readonly isIncludeBlankValue?: boolean;
}

export default function CustomDropDown({
  disabled = false,
  placeholder = "",
  sx,
  items,
  value = "",
  handleChange,
  className,
  values,
  isIncludeBlankValue = false,
}: CustomDropDownProps) {
  const { classes } = useStyles();

  // Convert value to string if it exists, otherwise use empty string
  const displayValue = value?.toString() || "";

  return (
    <FormControl
      className={clsx(classes.formControl, className)}
      sx={{
        ...sx,
      }}
    >
      {!displayValue && <Box className={classes.placeholder}>{placeholder}</Box>}
      <Select
        value={displayValue}
        disabled={disabled}
        onChange={handleChange}
        displayEmpty
        IconComponent={lucideSelectIcon(ChevronDown)}
        inputProps={{ "aria-label": placeholder || "Select an option" }}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          marginThreshold: 8,
          transitionDuration: { enter: 160, exit: 100 },
          PaperProps: {
            className: clsx(classes.menuPaper, "native-scrollbar"),
            elevation: 0,
          },
          MenuListProps: {
            className: classes.menuList,
            "aria-label": placeholder || "Dropdown options",
          },
        }}
      >
        {isIncludeBlankValue && (
          <MenuItem value="" className={classes.menuItem}>
            <Box className={classes.detail} sx={{ minHeight: 24 }}></Box>
          </MenuItem>
        )}
        {items?.map((item, index) => (
          <MenuItem
            key={index}
            value={values?.[index]?.toString() || item.toString()}
            className={classes.menuItem}
          >
            <Box className={classes.detail}>{item}</Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
